import { createRef } from "react"
import { ConfirmModalRef } from "../components/ConfirmModal"

export const confirmModal = createRef<ConfirmModalRef>()
